import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class K1CalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (K1CalculationMethodModel._instance == null) K1CalculationMethodModel._instance = new K1CalculationMethodModel(authManager);
        return K1CalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/k-1-calculation-methods', 'face-pressures/k-1-calculation-methods/codelist');

        this.entityName = 'face-pressures.K1CalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'K 1 Method';
        this.setLabel = 'K 1 Methods';

        this.browser = {
            name: 'default-face-pressures-k1calculationmethod-browser',
            moduleName: 'default-face-pressures-k1calculationmethod-browser',
            moduleTitle: 'K 1 Methods',
            moduleStateSlotName: 'default-face-pressures-k1calculationmethod-browser',
        };

        this.editor = {
            name: 'default-face-pressures-k1calculationmethod-editor',
            moduleName: 'default-face-pressures-k1calculationmethod-editor',
            moduleTitle: 'K 1 Method',
            moduleStateSlotName: 'default-face-pressures-k1calculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'isDefault',
                type: 'bool',
                persistent: true,
                label: 'Is Default',
            },
        ];

    }

}
